import { makeStyles } from '@material-ui/core/styles';

import { neutral, red } from 'shared/styles/colors';

export default makeStyles({
  banner: {
    minHeight: '2.8rem',
    padding: '.5rem 1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.75rem',
    color: neutral.white,
    backgroundColor: red['60'],
  },
  description: {
    flex: 1,
    fontSize: 'inherit',
  },
  img: {
    width: '1.5rem',
    height: '1.5rem',
  },
  cta: {
    padding: '0.25rem 0.5rem',
    fontSize: 'inherit',
    color: red['60'],
    backgroundColor: neutral.white,
    '&:hover': {
      color: red['70'],
      backgroundColor: neutral['10'],
    },
  },
  closeIcon: {
    width: '1rem',
    height: '1rem',
    fill: 'white',
    color: neutral.white,
  },
});
